import React, { useEffect } from "react";
import Styles from "./DashRecentCustomer.module.css";
import { Link, useNavigate } from "react-router-dom";
import { getRecentCustomersAction } from "../../../../store/actions/dashboard/DashboardActions";
import ShimmerLoader from "../../../pages/ShimmerLoader/ShimmerLoader";
import { useDispatch, useSelector } from "react-redux";
// import profile from "../../../../images/profile/profile.jpg";
import profile from "../../../../images/profile/profile.svg";

const DashRecentCustomers = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { customers, loading, error } = useSelector((state) => state.dashBoardRecentCustomers);
  const { active_customer } = useSelector((state) => state.dashBoardTotalActiveUser);

  useEffect(() => {
    dispatch(getRecentCustomersAction({}, navigate));
  }, [dispatch]);

  const roundedValue = (value) => {
    if (value < 10) return Math.floor(value);
    return Math.floor(value / 10) * 10;
  };

  if (loading) {
    return <ShimmerLoader />;
  }
  return (
    <>
      <div className={`${Styles.dashboard_card} card-body d-flex justify-content-between align-items-start`}>
        <p>Customers</p>
        <button className={`btn btn-primary ${Styles.cust_button} `}>
          <Link to='/customers'>View Details</Link>
        </button>
      </div>

      <div className='ms-4'>
        <div className={` ${Styles.flex_container}`}>
          {customers.map((data, index) => (
            <div key={index} className={`${Styles.Pic_container}`}>
              <img alt={data.name || "Customer"} src={data.image || profile} width='100%' />
            </div>
          ))}
        </div>
        <p className={`${Styles.growing_people} ms-2 mt-4 mb-5`}>We have over {roundedValue(active_customer.active_customer)}+ people connected with us and the number is growing!</p>
      </div>
    </>
  );
};

export default DashRecentCustomers;
